'use strict'

import Zepto from 'zepto-webpack'
import AbstractMonitor from '@/toolbar/inspector/Monitors/AbstractMonitor'
import Events from '@/configuration/Events'

export default class RefusedNotDefined extends AbstractMonitor {
  monitor() {
    const totalWithRefusedDefined = Zepto('[kr-post-url-refused]').size()
    if (totalWithRefusedDefined == 0) {
      this.$store.dispatch('warning', {
        errorCode: 'CLIENT_800',
        metadata: { console: true }
      })
    }

    return Promise.resolve(true)
  }
}
